var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocationListingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49998 18.3333C6.14671 17.2362 4.89234 16.0335 3.74999 14.7376C2.03571 12.7916 9.4167e-07 9.8935 9.4167e-07 7.13181C-0.000742519 5.7214 0.438759 4.34248 1.26288 3.16956C2.08701 1.99664 3.25871 1.08244 4.6297 0.54267C6.0007 0.00289887 7.50935 -0.138186 8.96474 0.137271C10.4201 0.412728 11.7568 1.09234 12.8057 2.09011C13.504 2.75086 14.0575 3.53667 14.4341 4.40208C14.8108 5.26748 15.0031 6.19529 15 7.13181C15 9.8935 12.9643 12.7916 11.25 14.7376C10.1076 16.0335 8.85325 17.2362 7.49998 18.3333ZM7.49998 4.07685C6.6475 4.07685 5.82994 4.39871 5.22714 4.97163C4.62435 5.54455 4.2857 6.32159 4.2857 7.13181C4.2857 7.94204 4.62435 8.71908 5.22714 9.292C5.82994 9.86491 6.6475 10.1868 7.49998 10.1868C8.35246 10.1868 9.17003 9.86491 9.77282 9.292C10.3756 8.71908 10.7143 7.94204 10.7143 7.13181C10.7143 6.32159 10.3756 5.54455 9.77282 4.97163C9.17003 4.39871 8.35246 4.07685 7.49998 4.07685Z",
    fill: "#FF3300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationListingIcon);
export default __webpack_public_path__ + "static/media/LocationListingIcon.18bc46a85850aa1cb025dfdbba963b5e.svg";
export { ForwardRef as ReactComponent };